import Vue from "vue";

let logjson = function (text, data) {
  if (typeof data == "object") {
    data = JSON.parse(JSON.stringify(data));
  }
  console.warn(text, data);
};

Vue.prototype.$logjson = logjson;
Vue.prototype.$log = logjson;







